module.exports = __webpack_public_path__ + "img/lowlowhighhighalarm_tankreservoir.fb445a32.svg";